import { render, staticRenderFns } from "./GuestWizardDocumentEditView.vue?vue&type=template&id=8bf0878c&scoped=true&"
import script from "./GuestWizardDocumentEditView.vue?vue&type=script&lang=ts&"
export * from "./GuestWizardDocumentEditView.vue?vue&type=script&lang=ts&"
import style0 from "./GuestWizardDocumentEditView.vue?vue&type=style&index=0&id=8bf0878c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf0878c",
  null
  
)

export default component.exports